export const START_NARRATIVE_NARROW_MEDIA_QUERY = '@media (max-width: 760px)' as const;
